import { render, staticRenderFns } from "./carousel.vue?vue&type=template&id=94a5057c&scoped=true&lang=html&"
import script from "./carousel.vue?vue&type=script&lang=js&"
export * from "./carousel.vue?vue&type=script&lang=js&"
import style0 from "./carousel.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./carousel.vue?vue&type=style&index=1&id=94a5057c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a5057c",
  null
  
)

export default component.exports